type AccessDocument = {
  status: number;
  allowed_stage_info: string[]; // Array of post_id strings
  message: string;
  };
  type Document = {
    post_id: string;
    post_name: string;
    document_status?: string;
  };
  type Stage = {
    stage_uid: string;
    stage_name: string;
    stage_status: string;
    documents?: Document[];
  };
  export const isPostIdPresent = (
    accessDoc: AccessDocument | null | undefined,
    postId: string
  ): boolean => {
    if (
      !accessDoc ||
      !accessDoc.allowed_stage_info ||
      accessDoc.allowed_stage_info.length === 0
    ) {
      return false;
    }
    return accessDoc.allowed_stage_info.includes(postId);
  };
  
  export   function getPostStatus(postId: string, data: Stage[]): string {
    for (const stage of data) {
        if (stage.documents) {
            for (const doc of stage.documents) {
                if (doc.post_id === postId) {
                    return doc.document_status || "";
                }
            }
        }
    }
    return "";
}






